import TubCommon from "./tubCommon";

export default class BathTubLiner extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_liner";
    this.bottomTubId = "bathtub_liner";
    this.visible = true;
    this.partName = "Tub Liner";
    this.translateId = "visualizer.bathroom.shower_tub_combo.bathtub_liner";
    this.dbName = "Bathtub Liner";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubLiner());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.Liner;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
